class @PermittedEmailInput

  constructor: (container) ->

    @$container = $(container)
    @$domain    = $("select.permitted_email_address_domain", @$container)
    @$localpart = $("input.permitted_email_address_localpart", @$container)

    # The adjustment code only runs if the email is being presented as the
    # input/select hybrid. On unrestricted organizations, it's a simple input
    # field and this is not needed.
    if @$domain.length == 1 && @$localpart.length == 1
      @$domain.on("change", @adjustVisibility)
      @adjustVisibility()

  showLocalPart: =>

    @$domain.val().substring(0, 1) == "@"

  adjustVisibility: =>

    if @showLocalPart()
      UI.setSelectWidth(@$domain, 325)
      @$localpart.show().removeAttr("disabled")
      $(".select2-container", @$container).css({ marginLeft: "2px", marginTop: "-2px" })
    else
      UI.setSelectWidth(@$domain, 580)
      @$localpart.hide().attr(disabled: "disabled")
      $(".select2-container", @$container).css({ marginLeft: "-2px", marginTop: "0px" })
